/**
 * Address of a list's cover, following the same rule as piece photos (`piece-image.ts`).
 *
 * Two key shapes are accepted deliberately: an **opaque** key, which is what the backend
 * sends and resolves against the env base, and a key that **already is an address**, which is
 * how an asset in the repository is named while the curated cover set does not come from the
 * server.
 */

export function isAddressLike(key: string): boolean {
  return key.startsWith("/") || key.startsWith("http://") || key.startsWith("https://");
}

export function resolveCoverUrl(coverKey: string | null): string | null {
  if (coverKey === null || coverKey.length === 0) return null;

  if (isAddressLike(coverKey)) return coverKey;

  const base = process.env.NEXT_PUBLIC_LIST_COVER_BASE_URL;
  if (base === undefined || base.length === 0) return null;

  return `${base.replace(/\/$/, "")}/${coverKey}`;
}
